import { validateAddress } from '../Shared/validations.js';

const validate = values => {
    const errors = {
        ...validateAddress(values)
    };

    return errors;
};

export default validate;
